export { useGetSpeciality } from './useGetSpeciality';
